import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';
import { FavouriteFarmsInitialState } from './types/favouriteFarmsTypes';

export const initialState: FavouriteFarmsInitialState = {
  favouriteFarms: {},
  isAddFarmToFavouritesError: false,
  isRemoveFarmFromFavouritesError: false,
  errorMessage: '',
  isGetFavouriteFarmsError: false,
  isMaximumFavouritesAmoundReachedError: false,
};

export const favouriteFarmsSlice = createSlice({
  name: 'favouriteFarms',
  initialState,
  reducers: {
    addFarmToFavouritesSuccess: (state, action) => {
      const farmIdThatWasAddedToFavourites = action.payload;
      state.isAddFarmToFavouritesError = false;
      state.isMaximumFavouritesAmoundReachedError = false;
      state.favouriteFarms[farmIdThatWasAddedToFavourites] = true;
    },
    addFarmToFavouritesError: (state, action: PayloadAction<string>) => {
      state.isAddFarmToFavouritesError = true;
      state.errorMessage = action.payload;
    },
    maximumFavouritesAmountReachedError: (state) => {
      state.isMaximumFavouritesAmoundReachedError = true;
    },
    removeFarmFromFavouritesSuccess: (state, action) => {
      const farmIdThatWasRemovedFromFavourites = action.payload;
      state.isRemoveFarmFromFavouritesError = false;
      state.isMaximumFavouritesAmoundReachedError = false;
      delete state.favouriteFarms[farmIdThatWasRemovedFromFavourites];
    },
    removeFarmFromFavouritesError: (state, action: PayloadAction<string>) => {
      state.isRemoveFarmFromFavouritesError = true;
      state.errorMessage = action.payload;
    },
    getFavouriteFarmsSuccess: (state, action: PayloadAction<string[]>) => {
      state.favouriteFarms = {};
      action.payload.forEach((currentFarmId) => {
        state.favouriteFarms[currentFarmId] = true;
      });
    },
    getFavouriteFarmsError: (state, action: PayloadAction<string>) => {
      state.isGetFavouriteFarmsError = true;
      state.errorMessage = action.payload;
    },
  },
});

export const addFarmToFavourites = createAction(
  'ADD_FARM_TO_FAVOURITES_REQUEST',
);
export const removeFarmFromFavourites = createAction(
  'REMOVE_FARM_FROM_FAVOURITES_REQUEST',
);
export const getFavouriteFarms = createAction('GET_FAVOURITE_FARMS_REQUEST');
export const MAXIMUM_NUMBER_OF_FAVOURITE_FARMS_ALLOWED = 15;

export const {
  addFarmToFavouritesSuccess,
  addFarmToFavouritesError,
  getFavouriteFarmsSuccess,
  getFavouriteFarmsError,
  removeFarmFromFavouritesSuccess,
  removeFarmFromFavouritesError,
  maximumFavouritesAmountReachedError,
} = favouriteFarmsSlice.actions;

// selectors
export const favouriteFarmsSelectors = {
  selectFavouriteFarms: (state: RootState) =>
    state.favouriteFarms.favouriteFarms,
  selectIsMaximumAmountOfFavouritesReached: (state: RootState) =>
    state.favouriteFarms.isMaximumFavouritesAmoundReachedError,
};

export default favouriteFarmsSlice.reducer;
